import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import HomeDashboard from './pages/HomeDashboard';
import Transparency from './pages/Transparency';
import Protocol from './pages/Protocol';
import Security from './pages/Security';
import Status from './pages/Status';

// Alliance & Gamification Pages
import Alliances from './pages/Alliances';
import AllianceDetail from './pages/AllianceDetail';
import CreateAlliance from './pages/CreateAlliance';
import Rewards from './pages/Rewards';
import Leaderboard from './pages/Leaderboard';

// New Pages
import Network from './pages/Network';
import Settings from './pages/Settings';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/home-dashboard" element={<HomeDashboard />} />
        <Route path="/transparency" element={<Transparency />} />
        <Route path="/protocol" element={<Protocol />} />
        <Route path="/security" element={<Security />} />
        <Route path="/status" element={<Status />} />

        {/* Alliance & Gamification Routes */}
        <Route path="/alliances" element={<Alliances />} />
        <Route path="/alliances/create" element={<CreateAlliance />} />
        <Route path="/alliance/:id" element={<AllianceDetail />} />
        <Route path="/rewards" element={<Rewards />} />
        <Route path="/leaderboard" element={<Leaderboard />} />

        {/* Network & Settings */}
        <Route path="/network" element={<Network />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </Router>
  );
}

export default App;
